import React from 'react';
import PageBanner from '../components/PageBanner';

const SECTIONS = [
  {
    title: '1. البيانات التي نجمعها',
    body: 'نجمع بيانات مثل الاسم، البريد الإلكتروني، رقم الهاتف، وعنوان الشحن عند إنشاء حساب أو إتمام عملية شراء، بجانب بيانات الاستخدام مثل المنتجات التي تتصفحها.',
  },
  {
    title: '2. كيف نستخدم بياناتك',
    body: 'نستخدم بياناتك لتنفيذ طلباتك، تحسين تجربتك على المنصة، إرسال تحديثات عن حالة الطلب، وتقديم عروض قد تهمك بناءً على تفضيلاتك.',
  },
  {
    title: '3. مشاركة البيانات',
    body: 'لا نبيع بياناتك الشخصية لأطراف ثالثة. نشارك فقط البيانات الضرورية مع شركاء الشحن وبوابات الدفع لإتمام عملية الطلب.',
  },
  {
    title: '4. أمان البيانات',
    body: 'نستخدم بروتوكولات تشفير وإجراءات أمنية معتمدة لحماية بياناتك من الوصول غير المصرح به أو الفقدان أو سوء الاستخدام.',
  },
  {
    title: '5. حقوقك',
    body: 'لك الحق في الاطلاع على بياناتك، تعديلها، أو طلب حذف حسابك بالكامل في أي وقت من خلال إعدادات الحساب أو بالتواصل معنا مباشرة.',
  },
  {
    title: '6. ملفات تعريف الارتباط',
    body: 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك على الموقع. لمزيد من التفاصيل راجع صفحة سياسة ملفات تعريف الارتباط.',
  },
];

const PrivacyPolicy = () => {
  return (
    <div dir="rtl">
      <PageBanner
        eyebrow="آخر تحديث: يوليو 2026"
        title="سياسة الخصوصية"
        subtitle="خصوصيتك مهمة بالنسبالنا. هنا هنشرح إزاي بنجمع ونستخدم ونحمي بياناتك."
      />

      <div className="container mx-auto px-4 py-14 max-w-3xl">
        <div className="space-y-8">
          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h2 className="text-lg font-bold text-[#1B1B1F] mb-2">{section.title}</h2>
              <p className="text-gray-600 leading-8">{section.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-[#F6F5F2] rounded-2xl text-sm text-gray-600 leading-7">
          لو حابب تعرف تفاصيل أكتر عن بياناتك أو عايز تطلب حذفها، تواصل معانا على{' '}
          <a href="mailto:privacy@memestore.sa" className="text-[#1B1B1F] font-bold underline decoration-[#F2B705]">
            privacy@memestore.sa
          </a>
          .
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
